import React from 'react'
import { MagicSpinner } from 'react-spinners-kit'
import { useStyles } from './Styles'

export const SearchLoader = ({ loading, extraClass }) => {
  let classes = useStyles()
  return (
    <div className={classes.SearchLoaderWrapper + (!!extraClass ? ` ${extraClass}` : '')}>
      <MagicSpinner
        size={100}
        color="#438fce"
        loading={loading}
      />
    </div>
  )
}
